import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlConstants} from '../constants/url-constants';

@Injectable({
  providedIn: 'root'
})
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(private urlConstants: UrlConstants) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({headers: request.headers.set('Access-Control-Allow-Methods', 'GET, POST, DELETE, PUT, OPTIONS')});
    request = request.clone({
      headers: request.headers.set('Content-Type', 'application/json')
    });

    return next.handle(request);
  }
}
